import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the mobileLayout state domain
 */

const selectMobileLayoutDomain = state => state.mobileLayout || initialState;

/**
 * Other specific selectors
 */
const makeSelectLoading = () =>
  createSelector(
    selectMobileLayoutDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectMobileLayoutDomain,
    substate => substate.error,
  );

/**
 * Default selector used by MobileLayout
 */

const makeSelectMobileLayout = () =>
  createSelector(
    selectMobileLayoutDomain,
    substate => substate,
  );

export {
  selectMobileLayoutDomain,
  makeSelectMobileLayout,
  makeSelectLoading,
  makeSelectError,
};
